export default __webpack_public_path__ + "d4ffece966f0c326ad5f44d4e2d0cf7b.png";